import { createContext, useState, useEffect } from 'react';
import { clearTokens, getAccessToken, getRefreshToken , getUserId , getUserName , getUserRole , getCompanyId , getCompanyLogo, setTokens} from '../helpers/tokenService';
import { DeviceAuthorization } from '../utils/authorization';
import API_BASE_URL from '../helpers/apiConfig';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  console.log('access:', getAccessToken());
  console.log('refresh:', getRefreshToken());
  console.log('id', getUserId());
  console.log('role:', getUserRole());
  console.log('name:', getUserName());

  useEffect(() => {
    const checkSSO = async () => {
      const isFromRaysuite = document.referrer && (
        document.referrer.includes('localhost:5173') ||
        document.referrer.includes('127.0.0.1:5173') ||
        document.referrer.includes('raysuite.raygain.com')
      );
      if (isFromRaysuite) {
        sessionStorage.removeItem('sso_logged_out');
      }

      const token = getAccessToken();
      if (token) {
        sessionStorage.removeItem('sso_logged_out');
        setIsAuthenticated(true);
        setLoading(false);
        return;
      }

      if (sessionStorage.getItem('sso_logged_out') === 'true') {
        setLoading(false);
        return;
      }

      // No token found. Try automatic SSO login via device key
      try {
        const deviceKey = await DeviceAuthorization.getDeviceAuthorizationKey();
        const response = await fetch(`${API_BASE_URL}/auth/sso-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ device_key: deviceKey }),
        });

        if (response.ok) {
          const data = await response.json();
          setTokens(
            data.accessToken,
            data.refreshToken,
            data.userId,
            data.role,
            data.userName,
            data.organizationId,
            data.companyLogo
          );
          localStorage.setItem('login_method', 'sso');
          sessionStorage.removeItem('sso_logged_out');
          setIsAuthenticated(true);
        } else {
          if (response.status === 403 || response.status === 404) {
            const data = await response.json();
            sessionStorage.setItem('sso_error', data.message || 'SSO authentication failed');
          }
        }
      } catch (err) {
        console.error('SSO validation check failed:', err);
      } finally {
        setLoading(false);
      }
    };

    checkSSO();
  }, []);

  const login = () => {
    sessionStorage.removeItem('sso_logged_out');
    setIsAuthenticated(true);
  };
  const logout = async () => {
    const loginMethod = localStorage.getItem('login_method');
    const wasSSO = loginMethod === 'sso';
    const deviceKey = await DeviceAuthorization.getDeviceAuthorizationKey();
    const token = getAccessToken();

    try {
      const headers = {
        'Content-Type': 'application/json'
      };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      // If logged in by key (SSO), pass device_key to log out from Raysuite as well.
      // If logged in without key (direct login), do not pass device_key so Raysuite is unaffected.
      const requestBody = wasSSO ? { device_key: deviceKey } : {};

      await fetch(`${API_BASE_URL}/auth/logout`, {
        method: 'POST',
        headers,
        body: JSON.stringify(requestBody)
      });
    } catch (err) {
      console.error('Failed to notify backend of logout:', err);
    }

    clearTokens();
    localStorage.removeItem('login_method');
    setIsAuthenticated(false);
    sessionStorage.setItem('sso_logged_out', 'true');

    if (wasSSO) {
      // Logged in by key -> Redirect to Raysuite sign-in page
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      const raysuiteSignInUrl = isLocalhost 
        ? "http://localhost:5173/sign-in" 
        : "https://raysuite.raygain.com/sign-in";
      window.location.replace(raysuiteSignInUrl);
    } else {
      // Logged in without key (direct login) -> Redirect cleanly to HRMS /login page
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '/login');
      }
      window.location.replace('/login');
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;